<div class="flex flex-column align-self-stretch">
  <div class="flex pb-2 font-bold text-lg">
    {{ headerTitleKey ? i18n.i18nLng()[headerTitleKey] : headerTitle }}
  </div>
  <p-table [value]="tableData" class="mt-1">
    <ng-template pTemplate="body" let-data>
      <tr>
        <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis pl-0 vertical-align-top"
            [ngClass]="data?.titleStyleClass ? data.titleStyleClass : null"
            [colSpan]="data?.titleColspan ? 2 : 1"
            [width]="titleColumnWidth">
          {{ data?.i18nTitleKey ? i18n.i18nLng()[data.i18nTitleKey] : data?.title }}
        </td>
        @if (!data?.titleColspan) {
          @if (data?.valueWrap) {
            <td class="flex-wrap overflow-hidden text-overflow-ellipsis vertical-align-top"
                [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                [width]="valueColumnWidth">
              {{ data?.i18nValueKey ? i18n.i18nLng()[data.i18nValueKey] : data?.value }}
            </td>
          } @else {
            @switch (data?.valueType) {
              @case ('PASSWORD') {
                <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis vertical-align-top"
                    [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                    [width]="valueColumnWidth">
                  <sps-masked-password [password]="data?.value"
                                       [showPassword]="showPassword">
                  </sps-masked-password>
                </td>
              }
              @default {
                <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis vertical-align-top"
                    [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                    [width]="valueColumnWidth">
                  {{ data?.i18nValueKey ? i18n.i18nLng()[data.i18nValueKey] : data?.value }}
                </td>
              }
            }
          }
        }
      </tr>
    </ng-template>
  </p-table>
</div>
